import React from "react";
import { useTranslation } from "react-i18next";

import { useProjectResourcesRetrieval } from "@planzone/view-models";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function AddResourcesButton(props: Props) {
  const { t } = useTranslation();
  const { projectResources } = useProjectResourcesRetrieval(props.project);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.form}>
          <div className={styles.group}>
            <div
              className={styles.openAllocatorButton}
              onClick={isVisible ? hide : show}
            >
              <AddAllocationIcon className={styles.icon} />
            </div>
            {isVisible && (
              <div className={styles.quickAllocationMenu}>
                <ResourceAllocationMenu
                  allocatedResources={[
                    ...projectResources.map(
                      (projectResource) => projectResource.resource,
                    ),
                    ...props.selectedResources,
                  ]}
                  openedViews={["resources"]}
                  select={(resources) => {
                    props.selectResources([
                      ...props.selectedResources,
                      ...resources,
                    ]);
                  }}
                  unSelect={(resources) =>
                    props.selectResources(
                      props.selectedResources.filter(
                        (resource) =>
                          !resources.find(({ uuid }) => uuid === resource.uuid),
                      ),
                    )
                  }
                  everyone={{
                    select: () => props.selectEveryone(true),
                    isPending: false,
                    isSelected: props.isEveryoneSelected,
                    unSelect: () => props.selectEveryone(false),
                  }}
                />
                {(!!props.selectedResources.length ||
                  props.isEveryoneSelected) && (
                  <button
                    type="button"
                    className={styles.clearButton}
                    onClick={() => {
                      props.selectResources([]);
                      props.selectEveryone(false);
                    }}
                  >
                    {t("addPlanzoneResourceToProject.clear")}
                  </button>
                )}
              </div>
            )}
            {(!!props.selectedResources.length || props.isEveryoneSelected) && (
              <div
                className={styles.removeButton}
                onClick={() => {
                  props.selectResources([]);
                  props.selectEveryone(false);
                }}
              >
                <p>
                  {t("addPlanzoneResourceToProject.removeSelectedResources")}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { AddResourcesButton };
